// extracted by mini-css-extract-plugin
export var avatar = "_i1-3";
export var avatarContainer = "_i1-2";
export var avatarSpacer = "_i1-5";
export var avatarSpacerContainer = "_i1-4";
export var avatarStackContainer = "_i1-1";
export var bubble = "_i1-0";
export var remainderBubble = "_i1-6";